import React, { useState, useEffect, useRef } from 'react';
import './MyInterestRatesSlider.css';

const MyInterestRatesSlider = ({ value, onChange, disabled }) => {
  const [sliderValue, setSliderValue] = useState(value);
  const sliderRef = useRef(null);

  useEffect(() => {
    setSliderValue(value);
  }, [value]);

  const handleSliderChange = (e) => {
    const newValue = parseFloat(e.target.value);
    setSliderValue(newValue);
    onChange(newValue);
  };

  const getBackgroundSize = () => {
    return { backgroundSize: `${(sliderValue * 100) / 25}% 100%` };
  };

  return (
    <div className={`my-interest-rates-slider ${disabled ? 'disabled' : ''}`}>
      <input
        ref={sliderRef}
        type="range"
        min="0"
        max="25"
        step="0.5"
        value={sliderValue}
        onChange={handleSliderChange}
        className="slider"
        disabled={disabled}
        style={getBackgroundSize()}
      />
      <div className="slider-labels">
        <span>0%</span>
        <span>25%</span>
      </div>
      <div className="slider-value">{sliderValue.toFixed(1)}%</div>
    </div>
  );
};

export default MyInterestRatesSlider;